var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('fin-dynamic-etf-filter-display',{attrs:{"filters":_vm.loadData,"hideFilter":_vm.hideFilter,"ignore-default-filters":_vm.ignoreDefaultFilters},on:{"input":function (val) { return _vm.$emit('input', val); }}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }